
import './style.scss';
import i18n from './../i18n';

function turnOnMobileTable() {
  const $table = $('.new-table');
  const $mobileTableWrappers = $('td.wrapper', $table);
  const $tableMainRows = $('tr.flex', $table);

  if (!$mobileTableWrappers.length) {
    $tableMainRows.each(function createMobileTables(idx, mainRow) {
      createMobileTable(mainRow);
    });
  }
}

function turnOffMobileTable() {
  const $table = $('.new-table');
  const $mobileTableWrappers = $('td.wrapper', $table);
  const $tableMainRows = $('tr.flex', $table);

  if ($mobileTableWrappers.length) {
    $tableMainRows.each(removeMobileTable);
  }
}

function createMobileTable($tableMainRow) {
  const $mobileTableContainer = $('<td class="wrapper"><table><tr>');
  const $mobileTableRow = $('tr', $mobileTableContainer);
  const $scrollableCells = $('.scrollable', $tableMainRow);
  const $seeMoreBox = $('<span>').addClass('see-more').text(i18n.SLIDE_LEFT_FOR_MORE);
  const $description = $('.description', $tableMainRow);

  $scrollableCells.each(function pushScrollableCellsToMobileTableRow(idx, cell) {
    const cellClone = $(cell).clone();
    $(cell).hide();
    $(cellClone).appendTo($mobileTableRow);
  });

  $seeMoreBox.appendTo($mobileTableContainer);
  $mobileTableContainer.insertBefore($description);
  $mobileTableContainer.on('scroll', handleMobileTableScroll);
}

function removeMobileTable(index, $tableMainRow) {
  const $mobileTableContainer = $('.wrapper', $tableMainRow);
  const $scrollableCell = $('.scrollable', $tableMainRow);

  $mobileTableContainer.each(function fetchScrollableCellsFromMobileTableRow(idx, cell) {
    $scrollableCell.insertBefore($(cell));
  });

  $mobileTableContainer.off();
  $mobileTableContainer.remove();
}

function handleMobileTableScroll(event) {
  const $table = $('.new-table');
  const $mobileTableContainer = $(event.currentTarget);
  const scrollPosition = $mobileTableContainer.scrollLeft();
  const $mobileTableWrappers = $('.wrapper', $table);
  const $mobileTable = $('table', $mobileTableContainer);
  const $seeMoreBoxes = $('.see-more', $table);
  const SCROLL_OFFSET = 30;

  $mobileTableContainer.addClass('scrolling');
  $mobileTableWrappers.not('.scrolling').scrollLeft(scrollPosition);
  $mobileTableContainer.removeClass('scrolling');

  const shouldHideScroll = (scrollPosition + $(window).outerWidth()) > ($mobileTable.outerWidth() - SCROLL_OFFSET);

  if (shouldHideScroll) {
    $seeMoreBoxes.addClass('hidden');
  } else {
    $seeMoreBoxes.removeClass('hidden');
  }
}

export { turnOnMobileTable, turnOffMobileTable };
